import React from 'react';

import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { useTranslation, Trans } from 'react-i18next';
import { RootState } from '../../store/rootReducer'
import { sign, clearError } from '../authenticode/authenticodeSlice'


import { UploadAndErrors} from '../upload/UploadAndErrors'


import { setFiles, reset} from '../upload/dropZoneSlice'

import ContentLayout  from '../layout/ContentLayout'

const Authenticode:React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  
  const { inSignCall, errorResult } = useSelector(
    (state: RootState) => state.authenticode, shallowEqual
  )
  const { files } =   useSelector((state: RootState) => state.dropZone) 
  
  let dimmerText:string=""
  if (inSignCall)
  {
    dimmerText=t("authenticode.wait")
  }
  return <ContentLayout>
    <div><Trans i18nKey="authenticode.description"><br/></Trans></div>
    <p></p>
    <UploadAndErrors inputFiles={files} 
      onChange={ (f) => { dispatch(setFiles(f)); dispatch(clearError()) } }
      uploadButtonCaption={t("authenticode.upload")}  
      cancelButtonCaption={t("authenticode.cancel")} 
      handleReset={ () => {dispatch(reset()); dispatch(clearError())}} 
      handleUpload={() => {dispatch(clearError()); dispatch(sign(files[0])) }}
      errorResult = {errorResult}
      dimmerText={dimmerText} />
  </ContentLayout>

}

export default Authenticode;